import "./Systems.module.css";
import Header from "@/reusable_sections/Header";
import ComprehensiveManagement from "./sections/ComprehensiveManagement";
import OurProcess from "./sections/OurProcess";
import Footer from "@/reusable_sections/Footer";
export default function SystemsPage() {
  return <div>
      <Header />
      <ComprehensiveManagement />
      <OurProcess />
      <Footer />
    </div>;
}